/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2017 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/

import { BrowserModule } from "@angular/platform-browser";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { HttpClientModule, HttpClientJsonpModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppComponent } from "./app.component";
import { TooltipModule } from "ng2-tooltip-directive";
import { AppSharedModule } from "./shared/app-shared.module";
import { CookieService } from "ngx-cookie-service";
import { HeaderComponent } from "./register-login/layout/header/header.component";
import { FooterComponent } from "./register-login/layout/footer/footer.component";
import { LandingPageComponent } from "./landing-page/landing-page/landing-page.component";
import { LoginComponent } from "./register-login/layout/login/login.component";
import { LayoutService } from "./register-login/services/layoutservice.service";
import { ServererrorComponent } from "./server-error/servererror.component";
import { LogoutComponent } from "./register-login/layout/logout/logout.component";
import { AgGridModule } from "ag-grid-angular/main";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
   LandingPageComponent,
    LoginComponent,
   ServererrorComponent,
    LogoutComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    TooltipModule,
    ReactiveFormsModule,
    HttpClientJsonpModule,    
    AppSharedModule,
    AgGridModule.withComponents([LandingPageComponent])
   
  ],
  providers: [LayoutService, CookieService],
  bootstrap: [AppComponent],
})
export class AppModule {}
